import React from 'react';
import styled from 'styled-components';

const Container = styled.svg``;

const ThinCheckMarkIcon = (props: any) => (
  <Container width="69" height="69" viewBox="0 0 69 69" {...props}>
    <title>Car Checkmark</title>
    <g>
      <svg
        width="69"
        height="69"
        viewBox="0 0 69 69"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.5 68C53.0015 68 68 53.0015 68 34.5C68 15.9985 53.0015 1 34.5 1C15.9985 1 1 15.9985 1 34.5C1 53.0015 15.9985 68 34.5 68Z"
          stroke="#00AED9"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49 22.0317L29.3824 47.0317L20 37.549"
          stroke="#00AED9"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </g>
  </Container>
);

export default ThinCheckMarkIcon;
